import { ActivityRuleViolationsState } from './types';

export default function initialState(): ActivityRuleViolationsState {
  return {
    data: [],
    fetching: false,
  };
}
